import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import Autosuggest from '~components/Autosuggest';
import Close from '~components/Icon/Close';
import Search from '~components/Icon/Search';
import ModalBase, { ModalBaseProps } from '~components/ModalBase';
import { ICompany } from '~types/company';

import * as S from './style';

interface Props extends ModalBaseProps {}

export default function ModalSearch({ isOpen, handleClose }: Props) {
  const [inputElement, setInputElement] = useState<HTMLInputElement | null>();
  const theme = useTheme();
  const router = useRouter();
  const [value, setValue] = useState<ICompany>({
    PK_NM_HASH: '',
    location: '',
    locationCode: '',
    name: '',
  });

  useEffect(() => {
    if (inputElement) {
      inputElement.focus();
    }
  }, [inputElement]);

  return (
    <ModalBase isOpen={isOpen} handleClose={handleClose} inlineCss={S.cssModalWrapper} maskClosable>
      <S.InputWrapper>
        <S.IconWrapper>
          <Search width={21} height={21} color={theme.colors.magenta700} />
        </S.IconWrapper>
        <Autosuggest
          value={value}
          renderInput={
            <S.Input
              ref={(element) => setInputElement(element)}
              type='text'
              placeholder='기업을 검색해보세요.'
              autoFocus
            />
          }
          setValue={(company) => setValue(company)}
          inlineCss={S.cssAutosuggest}
          listCss={S.cssAutosuggestList}
          handleChange={(value: ICompany) => {
            handleClose();
            router.push(`/company/${value.PK_NM_HASH}`);
          }}
        />
      </S.InputWrapper>
      <S.ButtonClose onClick={handleClose}>
        <Close />
      </S.ButtonClose>
    </ModalBase>
  );
}
